<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!--constraint-edit.component.html-->
<div
	[shakeAnimation]="makeShake"
	class="light-container light-container--border-radius ticket-edit-container"
	[formGroup]="editForm"
>
	<div class="ticket-message-grid">
		<ticket-message [message]="data.messageString"></ticket-message>
	</div>
	<!-- CONTENT UNIQUE TO TICKET TYPE -->
	<div class="ticket-edit-container-box constraint-viewport" #scrollToBottom>
		<div class="ticket-edit-container__content">
			<div *ngIf="isPlannedPreview" class="ticket-edit-container__planned-watermark-wrapper">
				<div class="ticket-edit-container__planned-watermark" automationId="constraintPlannedWatermark">
					PLANNED
				</div>
			</div>
			<div class="ticket-edit-container__header">
				<!-- TODO: Handle Assignee color -->
				<ticket-thumbnail
					[ticketType]="data.selectedType"
					[ticketRole]="data.data.liveRole"
					[etc]="data"
					[isComplete]="data.data.isActualized"
				>
				</ticket-thumbnail>
				<div class="ticket-edit-container__header-date ticket-edit-container__constriant-header-date">
					<ticket-calendar
						*ngIf="data.ticketsInPlanRegion"
						[open$]="calendarController$"
						formControlName="liveDateRange"
						[editForm]="editForm"
						[readOnly]="(planAccess$ | async) === PlanAccessLevel.archived"
					>
					</ticket-calendar>
				</div>
				<div class="ticket-edit-icons-container">
					<!-- <ticket-icons></ticket-icons> -->
				</div>
				<div class="ticket-edit-container__hamburger-menu">
					<ticket-action-menu
						automationId="constraintHamburgerMenu"
						[editTicketCombined]="data"
					></ticket-action-menu>
				</div>
			</div>
			<div class="ticket-edit-container__constraint-requested-by dropdown-set-width">
				<ticket-project-member
					formControlName="requestedByProjectMemberId"
					automationId="requestedByProjectMemberId"
					[projectMember]="projectMember$ | async"
					[allowNullSelection]="false"
					(changed)="requestedByChanged($event)"
					[projectMemberList$]="planState.projectMembersApi.data.list$"
					placeholderText="{{ strings.CONSTRAINT_REQUESTED_BY.toUpperCase() }}"
				>
				</ticket-project-member>
			</div>
			<div class="ticket-edit-container__location dropdown-set-width">
				<ticket-location
					[placeholder]="strings.CONSTRAINT_LOCATION.toUpperCase()"
					formControlName="locationId"
					automationId="locationId"
					[locationList]="planState.locationsApi.data.list$"
				>
				</ticket-location>
			</div>
			<!-- <div class="ticket-edit-container__description-container--full-width">
				<ticket-description formControlName="activityName"></ticket-description>
			</div> -->
			<div class="grid-ticket-subcomponent-wrapper ticket-edit-container__description-container--full-width">
				<ticket-description
					class="grid-ticket-subcomponent-wrapper__input ticket-description-fixed-height"
					[shouldFocus]="data.ticketJustAdded"
					formControlName="activityName"
				></ticket-description>
			</div>
			<div class="ticket-edit-container__constraint-requested-by-date">
				<div class="constraint-cal-input">
					<mat-form-field
						class="date-requested"
						*ngIf="editForm.get('dateRequestedAdapter') as dateRequestedControl"
					>
						<mat-label>{{ strings.CONSTRAINT_DUE_DATE.toUpperCase() }}</mat-label>
						<input
							matInput
							readonly
							[matDatepicker]="needbypicker"
							formControlName="dateRequestedAdapter"
							class="custom-field-list-input"
							automationId="constraintNeedByDatePicker"
							(click)="needbypicker.open()"
						/>
						<mat-error *ngIf="editForm.get('dateRequestedAdapter')?.errors">{{
							strings.ENTER_VALID_DATE_ERR
						}}</mat-error>
						<mat-datepicker-toggle
							automationId="needbypicker"
							matSuffix
							[for]="needbypicker"
						></mat-datepicker-toggle>
						<mat-datepicker touchUi #needbypicker></mat-datepicker>
					</mat-form-field>
				</div>
			</div>
			<div class="ticket-edit-container__constraint--assigned-to dropdown-set-width">
				<ticket-project-member
					(selected)="assignedToSelected()"
					formControlName="liveAssignedProjectMemberId"
					[allowNullSelection]="false"
					[projectMemberList$]="planState.projectMembersApi.data.list$"
					automationId="constraintSelectPerson"
					placeholderText="{{ strings.CONSTRAINT_ASSIGNED_TO.toUpperCase() }}"
				>
				</ticket-project-member>
			</div>
			<!-- External Schedule ID -->
			<div
				*ngIf="isAdmin$ | async"
				class="grid-ticket-subcomponent-wrapper__input ticket-edit-container__constraint-external-schedule"
			>
				<ticket-ext-sched-id formControlName="externalScheduleId"></ticket-ext-sched-id>
			</div>
			<!-- WBS Code -->
			<div
				*ngIf="(isAdmin$ | async) && (isWbsCodeEnabled$ | async)"
				class="grid-ticket-subcomponent-wrapper__input ticket-edit-container__constraint-wbs-code"
			>
				<ticket-wbs-code formControlName="wbsCode"></ticket-wbs-code>
			</div>
			<!-- Custom Fields -->
			<!-- Caution: The code within [ngClass] is for appropriately adjusting UI elements -->
			<!-- This is necessary because certain fields (external schedule ID and WBS code) are dynamically displayed based on the involved values. -->
			<!-- If future fields affect this as well, consider pushing a different strategy since this is not easily mantainable -->
			<custom-fields-list
				[editedTicketId]="editedTicketId$ | async"
				[combinedEdit$]="ticketEditService.combinedEdit$"
				[ticketEditCombinedData]="this.data"
				[customFieldsApi]="planState.customFieldsApi"
				[isFloatingTickets]="(planState.floatingTickets.editTicket$ | async)?.size ? true : false"
				[customFieldsListFormGroup]="customFieldsListFormGroup"
				[saveCustomFieldsRequested$]="saveCustomFieldsRequested$.asObservable()"
				[allowList$]="planState.allowedProjectLinks$"
				[cancelCustomFieldsRequested$]="cancelCustomFieldsRequested$.asObservable()"
				[planId]="planState.planId"
				[ngClass]="{
					'constraint-edit-custom-fields-list-with-wbs-code':
						(isAdmin$ | async) && (isWbsCodeEnabled$ | async),
					'constraint-edit-custom-fields-list-with-external-schedule': isAdmin$ | async,
					'constraint-edit-custom-fields-list-without-external-schedule': !(isAdmin$ | async)
				}"
			>
			</custom-fields-list>
			<!-- Extra padding at the end which is useful for the dropdowns that expand down into this area -->
			<div class="extra-space-at-bottom-of-edit-ui"></div>
		</div>
	</div>
	<!-- Footer -->
	<ticket-footer
		[actualPhase]="data.data.actualPhase"
		[showActualizedToggle]="
			(hasAccess$ | async) &&
			data.ticketsInPlanRegion &&
			data.data.side != 'pull' &&
			data.data.actualPhase !== 'actualizing'
		"
		[saveLabel]="footerLabelName"
		[formDirty]="isSaveEnabled"
		[formValid]="isFormValid"
		[isReadOnly]="isReadOnlyTicket || (planAccess$ | async) === PlanAccessLevel.archived"
		[isPlanRegion]="data.ticketsInPlanRegion"
		(onActualChange)="updateActualPhase($event)"
		(canceled)="cancel()"
		(saved)="footerSaveClicked()"
	>
	</ticket-footer>
</div>
